// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\NewPortCall\RecurringBatchRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';

// RecurringBatchRequestData is the class that RecurringBatchRequest serializes to/from
export interface RecurringBatchRequestData {
	
    Batch : RecurringBatchData | null;
	
    StopDate : /* ISO8601 */ string;
}

// RecurringBatchRequestOptions is the class which may be passed to the RecurringBatchRequest constructor to define optional initial data values
export interface RecurringBatchRequestOptions {
	
    Batch? : RecurringBatchOptions | null;
	
    StopDate? : /* ISO8601 */ string;
}

export class RecurringBatchRequest {
	
    public Batch : DataSignal<RecurringBatch | null>;
	
    public StopDate : DataSignal<TZDate>;

    constructor();
    constructor(data : RecurringBatchRequestOptions);
    constructor(data: RecurringBatchRequestOptions | null = null) {
	    
        this.Batch = S.value<RecurringBatch | null>(null);
	    
        this.StopDate = jsonableObservable(S.value<TZDate>(data && data.StopDate !== undefined ? new TZDate(data.StopDate) : new TZDate(0), TZDate.eq));
    }

    static key(obj : RecurringBatchRequest) {
        return ;
    }
    
    static dataKey(obj : RecurringBatchRequestOptions) {
        return ;
    }

    static update(obj : RecurringBatchRequest, data : RecurringBatchRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.StopDate !== undefined) obj.StopDate(new TZDate(data.StopDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/RecurringBatchRequest.ts